import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import {
  BACK_HOME,
  DENIED_STATUS,
  DENIED_SUB_TITLE,
  DENIED_TITLE,
} from "../../constants/pages";
import { HOMEPAGE_PATH } from "../../constants/auth";
import { IAppStore } from "../../stores/Interfaces";
import Spinner from "../../components/common/Spinner";

interface Props {
  store?: IAppStore;
}

const DeniedPage: React.FC<Props> = ({ store }) => {
  return (
    <div>
      <Spinner isActive={!store?.userStore.user} hasBackground />
      <Result
        status={DENIED_STATUS}
        title={DENIED_TITLE}
        subTitle={DENIED_SUB_TITLE}
        extra={
          <Link to={HOMEPAGE_PATH} className="ant-btn ant-btn-primary">
            {BACK_HOME}
          </Link>
        }
      />
    </div>
  );
};

export default inject("store")(observer(DeniedPage));
